<template>
	<div class="functions-card">
		<div class="card-header">
			<div class="title">{{ title }}</div>
			<div class="right" v-if="titleRight" @click="goToPage(titleRight)">
				<span class="txt">{{ titleRight.text }}</span>
				<i :class="['iconfont', titleRight.icon]"></i>
			</div>
		</div>
		<div class="card-body">
			<div class="fun-item" v-for="(item, idx) in funList" :key="idx" @click="goToPage(item)">
				<span :class="['iconfont', 'fun-item-icon', item.icon]">
					<text v-if="item.badge && item.badge.show" :class="['badge', item.badge.type]">
						{{ item.badge.text }}
					</text>
				</span>
				<div class="fun-name">{{ item.name }}</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		cardData: {
			type: Object,
			default: () => {},
		},
	},
	computed: {
		title() {
			return this.cardData.title;
		},
		titleRight() {
			return this.cardData.titleRight;
		},
		funList() {
			return this.cardData.list;
		},
	},
	methods: {
		goToPage(item) {
			this.$emit('goToPage', item);
		},
	},
};
</script>

<style lang="scss" scoped>
.functions-card {
	margin-top: 8px;
	padding: 8px 8px 16px;
	border-radius: 5px;
	color: #333333;
	background-color: #fff;
}
.card-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 12px;

	.title {
		font-size: 15px;
		font-weight: 500;
		line-height: 21px;
	}
	.right {
		color: #595959;
		font-size: 12px;
		font-weight: normal;
		line-height: 16px;
		display: flex;
		align-items: center;
		.txt {
			margin-right: 4px;
		}
	}
	.iconfont {
		font-size: 10px !important;
	}
}
.card-body {
	display: flex;
	gap: 4px;

	.fun-item {
		width: calc(25% - 3px);
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;

		.fun-item-icon {
			font-size: 28px !important;
			color: #5f6fc9;
			position: relative;
		}
		.fun-name {
			padding-top: 4px;
			color: #333333;
			font-size: 12px;
			line-height: 16px;
		}
	}
}
.badge {
	position: absolute;
	left: 50%;
	top: -4px;
	min-width: 16px;
	padding: 0 4px;
	height: 16px;
	line-height: 14px;
	font-size: 12px;
	font-weight: 400;
	color: #ffffff;
	text-align: center;
	border: 1px solid #ffffff;
	border-radius: 8px;

	&.danger {
		background: #ef3838;
	}
}
</style>
